import { Link } from "react-router-dom";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { LandingHeader } from "./landing/LandingHeader";
import Footer from "../partials/Footer";



export const ResetEmailSent = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//   // 🚨 protect access
//   useEffect(() => {
//     if (!location.state?.fromReset) {
//       toast.error("Unauthorized access");
//       navigate("/login");
//     }
//   }, [location, navigate]);

//   // prevent UI flash
//   if (!location.state?.fromReset) return null;

  return (
    <>
      <LandingHeader />
      <main style={{ height: "80vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="bg-white p-5 text-center shadow rounded" style={{ maxWidth: "500px", width: "100%" }}>
          
          <FaEnvelopeOpenText size={50} style={{ color: "#0d6efd", marginBottom: "20px" }} />

          <h2 className="mb-3">Check Your Email</h2>

          <p className="text-muted">
            Please check your inbox and follow the instructions to reset your password.If you don’t see it, kindly check your spam or junk folder as well.
          </p>

          <Link to="/login" className="btn btn-primary mt-3">
            Back to Login
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
};